import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["query"];
import Alert from 'developer-docs-mdx-components/components/Alert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { connect } from 'react-redux';
import UILink from 'UIComponents/link/UILink';
import { selectSearchQuery } from '../../selectors/searchState';
import { getSearchRedirectUrl } from '../../utils/urls';
import styled from 'styled-components';
import { ALERT_CONTAINER_MAX_WIDTH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const AlertContainer = styled.div.withConfig({
  displayName: "OldSiteRedirectAlert__AlertContainer",
  componentId: "uvewyg-0"
})(["max-width:", "px;"], ALERT_CONTAINER_MAX_WIDTH);
function OldSiteRedirectAlert(_ref) {
  let {
      query
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const alertMessageProps = {
    elements: {
      strong: 'strong',
      Link: UILink
    },
    options: {
      query,
      linkProps: {
        href: getSearchRedirectUrl(query),
        external: true
      }
    }
  };
  return /*#__PURE__*/_jsx(AlertContainer, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      children: query ? /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
        message: "developer-docs-ui.search.alert_jsx"
      }, alertMessageProps)) : /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
        message: "developer-docs-ui.search.alertNoQuery_jsx"
      }, alertMessageProps))
    })
  }));
}
const mapStateToProps = state => {
  return {
    query: selectSearchQuery(state)
  };
};
export default connect(mapStateToProps)(OldSiteRedirectAlert);